import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWaveAuth } from '../../context/WaveAuthContext';
import waveAuth from '../../services/wave/waveAuth';
import './Callback.css';

function WaveAuth() {
  const { isAuthenticated } = useWaveAuth();
  const navigate = useNavigate();

  console.log('WaveAuth render - isAuthenticated:', isAuthenticated);

  const handleAuthClick = async () => {
    try {
      console.log('Starting Wave auth flow...');
      if (isAuthenticated) {
        console.log('Already authenticated, navigating to home');
        navigate('/');
        return;
      }
      const authUrl = waveAuth.initiateAuth();
      window.location.href = authUrl;
    } catch (error) {
      console.error('Failed to initiate auth:', error);
    }
  };

  return (
    <div className="callback-loading" style={{ textAlign: 'center', padding: '40px' }}>
      <h2>Wave Integration</h2>
      <p>Connect your Wave account to continue</p>
      <button 
        onClick={handleAuthClick}
        style={{
          padding: '12px 24px',
          backgroundColor: '#0073ea',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          marginTop: '20px'
        }}
      >
        Connect Wave Account
      </button>
    </div>
  );
}

export default WaveAuth;
